import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaUser, FaEnvelope, FaLock, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('User');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    if (message) {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            navigate('/login');
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [message, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;
    if (!passwordRegex.test(password)) {
      setError('Password must be at least 6 characters, include an uppercase letter, a lowercase letter, and a number');
      return;
    }

    setError('');

    try {
      const res = await axios.post('/api/auth/register', { username, email, password, role });
      setMessage(res.data.message);
      setError('');
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred during registration');
      setMessage('');
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Register</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.inputGroup}>
          <FaUser style={styles.icon} />
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
            style={styles.input}
          />
        </div>
        <div style={styles.inputGroup}>
          <FaEnvelope style={styles.icon} />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            style={styles.input}
          />
        </div>
        <div style={styles.inputGroup}>
          <FaLock style={styles.icon} />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            style={styles.input}
          />
        </div>
        <div style={styles.inputGroup}>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
            style={styles.input}
          >
            <option value="User">User</option>
            <option value="Miner">Miner</option>
            <option value="Promoter">Promoter</option>
            <option value="Investor">Investor</option>
            <option value="Project CEO">Project CEO</option>
          </select>
        </div>
        <button type="submit" style={styles.button}>Register</button>
      </form>
      {error && (
        <p style={{ ...styles.message, color: '#f00' }}>
          <FaExclamationCircle style={styles.iconMessage} /> {error}
        </p>
      )}
      {message && (
        <div>
          <p style={{ ...styles.message, color: '#28a745' }}>
            <FaCheckCircle style={styles.iconMessage} /> {message}
          </p>
          <p style={styles.countdownMessage}>
            Redirecting to login in {countdown} seconds...
          </p>
        </div>
      )}
      <p style={styles.loginLink}>
        Already have an account? <Link to="/login">Login here</Link>
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '0 auto',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#f4f4f4',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '24px',
    marginBottom: '20px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    padding: '10px',
    backgroundColor: '#fff',
  },
  icon: {
    marginRight: '10px',
  },
  input: {
    width: '100%',
    padding: '10px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  message: {
    marginTop: '15px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  countdownMessage: {
    marginTop: '10px',
    fontSize: '14px',
    color: '#555',
  },
  iconMessage: {
    marginRight: '5px',
  },
  loginLink: {
    marginTop: '15px',
    fontSize: '14px',
  },
};

export default Register;
